const coverContent = [
  {
    "key": "a01",
    "title": "About Me",
    "skills": "Designer",
    "content": [
      {
        "component": "Combination",
        "design": "image-one-third",
        "source": "about/nick-portrait-round_500.png",
        "title": "Loyal, Hard-working, Goal-oriented.",
        "content": "Over 10 years, I've mastered software like the Adobe Creative Suite and refined my creative process that brings results. I've also proven my strengths in the space of user experience design and web development. Teams benefit from my exceptional attention to detail and ability to self-prioritize. You won't find a more capable and efficient team member ready to make your dreams a reality!"
      },
      {
        "component": "Button",
        "content": "More About Me",
        "design": "button-1",
        "destination": "./about"
      }
    ]
  }
]
export default coverContent;